$(function() {

    function createCookie(name,value,days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime()+(days*24*60*60*1000));
            var expires = "; expires="+date.toGMTString();
        }
        else var expires = "";
        document.cookie = name+"="+value+expires+"; path=/";
    }

    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    function showEm(user, host) {
        e = user + "@";
        for (i = 0; i < host.length; i++) {
            e = e + host[i];
        }
        return "<a href='mailto:" + e + "'>" + e + "</a>";
    }

    $('span.address').html(showEm('kontakt', 'generato.pl'));

    if (readCookie('cookieBar') !== null) {
        $('#popup-cookie').hide();
    }

    $('#popup-cookie-btn').click(function() {
        createCookie('cookieBar', 1, 360);
        $('#popup-cookie').hide('fast');
    });

    $('#contactForm button').click(function() {

        var form = $('#contactForm');

        if (form.find('#name').val() === '' || form.find('#email').val() === '' || form.find('#message').val() === '' || (!form.find("#rights").is(':checked'))) {
            alert('Uzupełnij formularz.');
        } else {
            form.attr('action', '/contact').submit();
        }

    });

});



//////////////////
// WEBPACK FOOTER
// ./assets/js/src/script.js
// module id = 83
// module chunks = 0